// ##### 25-02-05 Komarov
import { Select } from 'antd';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectDeviceType } from '../../../../Redux/selectors';
import { useHistory } from 'react-router-dom';

// ##### 25-04-23 Komarov
import {
  getLangResponse,
  getPages,
  setLanguage,
} from '../../../../Redux/actions';
// ##### 25-03-20 Komarov
import config from '../../../../Redux/config';

// ##### Komarov 2025-07-14
const LangSelect = ({ dropdownStyle }) => {
  // ##### 24-05-10 Komarov
  const deviceType = useSelector(selectDeviceType);
  // ##### 23-12-27 Komarov
  const locale = useSelector(state => state.language);

  // ##### 25-03-20 Komarov
  const { supportedLangs } = config;
  const history = useHistory();
  const { Option } = Select;

  const currentUrl = useSelector(state => state.currentUrl);

  const dispatch = useDispatch();

  // ##### 25-03-26 Komarov
  const selectLanguage = value => {
    history.push(`/${value + currentUrl}`);
    // ##### 25-03-26 Komarov
    dispatch(getPages(value));
    // Устанавливаем выбранный язык в Redux, в объект locale
    dispatch(getLangResponse(value));
    // ##### 23-05-04 Komarov
    // Устанавливаем выбранный язык в Redux, в поле language
    dispatch(setLanguage(value));
  };

  return (
    <Select
      // ##### 24-07-24 Komarov: использование value позволяет изменить выбранное значение языка при смене locale (defaultValue не позволяло)
      // defaultValue={locale}
      value={locale}
      // ##### 22-11-14 Komarov
      dropdownStyle={dropdownStyle}
      // ##### 25-03-26 Komarov
      onChange={selectLanguage}
      bordered={true}
      // ##### 23-03-24 Komarov
      // size="small"
      // ##### 24-08-16 Komarov
      size={deviceType === 'tablet' ? 'middle' : 'small'}
    >
      <>
        {supportedLangs?.map(item => (
          <Option value={item} key={item}>
            {/* ##### 22-11-10 Komarov */}
            {item}
          </Option>
        ))}
      </>
    </Select>
  );
};

// ##### 25-05-21 Komarov
export default LangSelect;
